/* index.js */

"use strict";
const _ = require("lodash");

module.exports = {
    checkboxFormatter,
    nameFormatter,
    workflowFormatter
};

function checkboxFormatter(row, cell, value, columnDef, dataContext) {
    let checkbox = document.createElement("div");
    const isTitle = _.get(dataContext, "title", false);
    if (value && !isTitle) {
        if(typeof value === 'boolean') {
            checkbox = document.createElement("base-icon-gl");
            checkbox.dataset.icon = "common.check";
            checkbox.setDarkTheme(true);
        } else {
            checkbox.classList.add("read-only-block");
        }
        
    }

    if (_.get(dataContext, "title", false)) {
        checkbox.classList.add("title-block");
    } else if (!_.get(dataContext, "available", false)) {
        checkbox.classList.add("read-only-block");
    }
    return checkbox.outerHTML;
}

function nameFormatter(row, cell, value, columnDef, dataContext) {
    const name = document.createElement("div");
    if (
        !_.get(dataContext, "title", false) &&
        !(
            _.get(dataContext, "category", "") === "All" &&
            _.get(dataContext, "description", "") === "Global"
        )
    ) {
        name.classList.add("name-column");
    }
    name.innerText = value || "";
    name.setAttribute("title", value);
    return name.outerHTML;
}

function workflowFormatter(row, cell, value, columnDef, dataContext) {
    // console.log(row, cell, value, columnDef, dataContext);
    const workflowEl = document.createElement("div");
    workflowEl.classList.add("general-column");
    
    workflowEl.setAttribute("title", value);
    if(!dataContext.title) {
        workflowEl.innerText = value ? (_.get(dataContext.workflows[value],'name', 'None')) :'None';
        if(!dataContext.workflow && dataContext.value) {
            workflowEl.classList.add("disabled");
        }
    }
    return workflowEl.outerHTML;
}
